import { render } from "./InterestsSection.vue?vue&type=template&id=47366234&scoped=true"
import script from "./InterestsSection.vue?vue&type=script&lang=js"
export * from "./InterestsSection.vue?vue&type=script&lang=js"

import "./InterestsSection.vue?vue&type=style&index=0&id=47366234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47366234"]])

export default __exports__